<template>
    <header v-if="footer.logo" class="mb-16">
        <a :href="footer.logoLink">
            <span class="sr-only">Logo</span>
            <img class="h-8 w-auto" :src="imgUrl + footer.logo" alt="Logo" />
        </a>
    </header>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "TermsHeader",
    props: {
        footer: Object,
    },
    computed: {
        ...mapState(["imgUrl"]),
    },
};
</script>
